module.exports = __webpack_public_path__ + "static/complex_scroll_3-8e1fcb6b596185b28ff30553ec5fb00a.png";